import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'PropertyARV | Real Estate Investment Analysis Software',
  description = 'Analyze real estate deals in seconds. Calculate ARV, estimate repairs, find comps, and determine ROI instantly. Built for flippers, wholesalers, and rental investors.',
  keywords = 'real estate investing, ARV calculator, property analysis, fix and flip, wholesale real estate',
  image = '/og-image.png',
  url = 'https://propertyarv.com',
  type = 'website'
}) => {
  const fullTitle = title.includes('PropertyARV') ? title : `${title} | PropertyARV`;
  
  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: 'title', content: fullTitle },
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:type', content: type },
        { property: 'og:url', content: url },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: description },
        { property: 'og:image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:url', content: url },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: image },
      ]}
    />
  );
};

export default SEO;
